module.exports = __webpack_public_path__ + "675818f4e1c0afc9d3b2476194977a79.png";